import { TS_OfferMoreHotel } from "../TravelSeller/Models/TS_OfferMoreHotel";
import { BookingItemInterface } from "./BookingItemInterface";

export class OfferMoreHotel extends TS_OfferMoreHotel implements BookingItemInterface {}
